import React from 'react'

export const Footer = () => {
    return (
        <div className="footer__information">
                <p>Designed & Build by Mauricio Yepez</p>
        </div>
    )
}
